import fileApi from '@/api/common/file';
import msgUtil from '@/utils/message';
import { isEmpty } from './basic';

export function applicationLauncher() {
  const command = 'EXECUTE';
  let type = '';
  let module = '';
  let param = '';
  let ipAddress = '';
  let port = 0;

  return {
    convertNullValue(obj) {
      if (isEmpty(obj)) {
        return ' ';
      }
      return obj;
    },
    directExecute(exectype, obj, targetCmp) {
      const convertNullValue = this.convertNullValue;

      if (exectype === 'TELNET' || exectype === 'SSH' || exectype === 'FTP' || exectype === 'FTP_FILE_MANAGER') {
        if (isEmpty(obj)) {
          this.$message(msgUtil.getCustomMsgData('실행에 필요한 정보가 부족합니다.\n관리자에게 문의해주세요'));
          return;
        }
      }

      if (!isEmpty(obj)) {
        ipAddress = obj.ipaddressApplytype === 'IPv4' ? obj.ipaddressIpv4 : obj.ipaddressIpv6;
      }

      if (exectype === 'TELNET' || exectype === 'SSH') {
        if (!isEmpty(obj) && (obj.objtypeId === 'WINSVR')) {
          type = 'EXE';
          module = 'mstsc.exe';
          if (!isEmpty(obj.rdpPort)) {
            param = `/v:${ipAddress}:${obj.rdpPort} /admin`;
          } else {
            param = `/v:${ipAddress} /admin`;
          }
        } else {
          type = 'EXE';
          if (exectype === 'TELNET') {
            port = !isEmpty(obj.telnetPort) && obj.telnetPort > 0 ? obj.telnetPort : 23;

            if (isEmpty(obj.telnetuserId1) && isEmpty(obj.telnetuserId2)) {
              module = '%LAUNCHER_DIR%\\ttermpro.exe';
              param = `${ipAddress}:${port}\t /telnet`;
            } else {
              module = '%LAUNCHER_DIR%\\ttpmacro.exe';
              param = `telnet\t${ipAddress}:${port}\t\t`;
              param = `${param}${convertNullValue(isEmpty(obj.telnetuserId1) ? 'aaa' : convertNullValue(obj.telnetuserId1))}\t`;
              param = `${param}${convertNullValue(obj.telnetuserPw1)}\t`;
              param = `${param}${convertNullValue(obj.telnetuserId2)}\t`;
              param = `${param}${convertNullValue(obj.telnetuserPw2)}`;
            }
          } else {
            port = !isEmpty(obj.sshPort) && obj.sshPort > 0 ? obj.sshPort : 22;
            module = '%LAUNCHER_DIR%\\ttermpro.exe';
            param = isEmpty(obj.telnetuserId1) ? `${ipAddress}:${port}\t` : `ssh://${obj.telnetuserId1}:${obj.telnetuserPw1}@${ipAddress}:${port}/ /auth=password`;
          }
        }
      } else if (exectype === 'PING') {
        type = 'EXE';
        module = '%LAUNCHER_DIR%\\WAE_Ping.exe';
        if (!isEmpty(obj)) {
          param = ipAddress;
        }
      } else if (exectype === 'PATH_PING') {
        type = 'CLI';
        module = 'pathping.exe';
        param = `${ipAddress} &&pause`;
      } else if (exectype === 'TRACE_ROUTE') {
        type = 'EXE';
        module = '%LAUNCHER_DIR%\\WAE_TraceRT.exe';
        param = ipAddress;
      } else if (exectype === 'FTP') {
        type = 'EXE';
        module = 'ftp.exe';
        param = isEmpty(obj.ftpuserId) ? ipAddress : `open ${ipAddress}\t${convertNullValue(obj.ftpuserId)}\t${convertNullValue(obj.ftpuserPw)}\t`;
      } else if (exectype === 'LINK_WWW') {
        type = 'LINK_WWW';
        let tempUrl = !isEmpty(obj.linkWwwUrl) ? obj.linkWwwUrl : ipAddress;
        if (!/^https?:\/\//i.test(tempUrl)) {
          tempUrl = `http://${tempUrl}`;
        }
        window.open(tempUrl);
        return;
      } else if (exectype === 'LINK_APP') {
        type = 'LINK_APP';
        module = convertNullValue(!isEmpty(obj.linkAppPath) ? obj.linkAppPath : null);
      } else if (exectype === 'NET_STAT') {
        type = 'EXE';
        module = '%LAUNCHER_DIR%\\WAE_NetStat.exe';
        if (!isEmpty(obj)) {
          param = `${ipAddress} ${!isEmpty(obj.snmpCommunityRead) ? obj.snmpCommunityRead : null}`;
        }
      } else if (exectype === 'FTP_FILE_MANAGER') {
        type = 'EXE';
        module = '%LAUNCHER_DIR%\\WAE_FtpFileManager.exe';
        param = isEmpty(obj.ftpuserId) ? ipAddress : `${ipAddress} ${!isEmpty(obj.ftpuserId) ? obj.ftpuserId : ''} ${!isEmpty(obj.ftpuserPw) ? obj.ftpuserPw : null}`;
      } else if (exectype === 'RMON_BROWSER') {
        type = 'EXE';
        module = '%LAUNCHER_DIR%\\WAE_RmonExplorer.exe';
        param = `${ipAddress} ${!isEmpty(obj.snmpCommunityRead) ? obj.snmpCommunityRead : null} ${!isEmpty(obj.snmpCommunityReadwrite) ? obj.snmpCommunityReadwrite : null}`;
      } else if (exectype === 'REMOTE_VIEWER') {
        type = 'EXE';
        module = '%LAUNCHER_DIR%\\WatchAll_Remote_Viewer.exe';
        param = ipAddress;
      } else if (exectype === 'MSTSC') {
        type = 'EXE';
        module = 'mstsc.exe';
      } else if (exectype === 'TTERMPRO') {
        type = 'EXE';
        module = '%LAUNCHER_DIR%\\ttermpro.exe';
      }

      const buffer = `COMMAND[:]${command}\nTYPE[:]${type}\nMODULE[:]${module}\nPARAM[:]${param}\n[EOF_EXECUTE]`;

      // $socket이 생성되지 않았거나 연결이 되어있지 않은 경우
      if (isEmpty(targetCmp.$socket) || targetCmp.$socket.readyState === 0) {
        targetCmp.$connect();
        targetCmp.$socket.onopen = () => {
          this.sendToMessage(targetCmp, buffer);
          delete targetCmp.$socket.onoepn;
        };
        targetCmp.$socket.onerror = () => {
          targetCmp.$disconnect();
          targetCmp.$confirm(...msgUtil.getCustomConfirmData('WatchAll Launcher가 설치되어 있지 않았거나 실행 되고 있지 않습니다.\nWatchAll Launcher 설치를 진행하시겠습니까?')).then(() => {
            fileApi.downloadSetupFile('LAUNCHER');
          });
        };
      } else {
        this.sendToMessage(targetCmp, buffer);
      }
    },
    sendToMessage(targetCmp, message) {
      if (targetCmp.$socket.readyState === 1) {
        targetCmp.$socket.send(message);
      } else if (targetCmp.$socket.readyState === 3) {
        targetCmp.$socket.onerror();
      }
    },
    openIpScanPopup(objId) {
      const host = window.location.origin;
      if (isEmpty(objId)) {
        window.open(`${host}/#/ip-scan`, 'IP SCAN', 'width=850px, height=800px');
      } else {
        window.open(`${host}/#/ip-scan/${objId}`, 'IP SCAN', 'width=850px, height=800px');
      }
    },
    openMibBrowserPopup(objId) {
      const host = window.location.origin;
      if (isEmpty(objId)) {
        window.open(`${host}/#/mib-browser`, 'MIB BROWSER', 'width=900px, height=800px');
      } else {
        window.open(`${host}/#/mib-browser/${objId}`, 'MIB BROWSER', 'width=1050px, height=800px');
      }
    },
  };
}

export default applicationLauncher;



// WEBPACK FOOTER //
// ./src/utils/applauncher.js